import { Download } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'

export interface ChartExportActionsProps {
  onExportXlsx: () => void
  onExportImage: () => void
  isExportingXlsx?: boolean
  xlsxDisabled?: boolean
}

export const ChartExportActions = ({
  onExportXlsx,
  onExportImage,
  isExportingXlsx,
  xlsxDisabled,
}: ChartExportActionsProps) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="ghost" size="sm" className="shrink-0 gap-1.5 px-2 text-xs">
        Export
        <Download className="size-3" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem onClick={onExportXlsx} disabled={isExportingXlsx || xlsxDisabled}>
        Export as XLSX
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onExportImage}>Export as Image</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
)
